import script from "./PraPresentasiPJPBaruPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PraPresentasiPJPBaruPage.vue?vue&type=script&setup=true&lang=js"

import "./PraPresentasiPJPBaruPage.vue?vue&type=style&index=0&id=a1382fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1382fa0"]])

export default __exports__